module.exports = __webpack_public_path__ + "static/media/litigeBlanc.7378d18b.svg";